import React, { useState } from "react";
import {
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignMiddleIcon,
  AlignRightIcon,
  BoldIcon,
  CodeIcon,
  ColorLensArrowIcon,
  ColorLensIcon,
  ImageIcon,
  ItalicIcon,
  UnderlineIcon,
} from "../common/Icon";
import ColorPickerModal from "../common/ColorPickerModal";
import { useStateProvider } from "../common/StateProvider";
import RichTextEditor from "react-rte";

const LogChatNotesModal = ({ setLogChatNotesModal }) => {
  const [color, setColor] = useState("#000"); // Default color
  const [showColorModal, setShowColorModal] = useState(false); //Color Modal
  const [isItalic, setIsItalic] = useState(false);
  const { setLogChatModal } = useStateProvider(); //Set Daily Plan Modal
  const { setQuickActionModal } = useStateProvider();

  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  const changeTextColor = () => {
    document.getElementById("text-to-change").style.color = color;
    setShowColorModal(true);
  };

  const textStyles = {
    fontStyle: isItalic ? "italic" : "normal",
  };
  const toggleItalic = () => {
    setIsItalic(!isItalic);
  };

  // OVERLAY BEHIND FILTER MODEL
  const overLayHidden = () => {
    setLogChatNotesModal(false);
    setLogChatModal(false);
    setQuickActionModal(false);
  };
  const [value, setValue] = useState(RichTextEditor.createEmptyValue());

  const onChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="px-[18px] py-[21px] h-full flex flex-col relative bg-white rounded-[12px] shadow-todays_workflow_box_shadow ">
        <div className=" flex flex-col flex-grow justify-between">
          <div className="log_chat rounded-xl border border-solid border-[rgba(0,_0,_0,_0.20)] overflow-x-auto w-[320px] xs:w-[340px] md:w-auto md:overflow-x-visible">
            {/* <div className="px-[31px] py-2 overflow-x-auto overflow_x_scroll_style rounded-md bg-[rgba(111,_106,_248,_0.05)]  w-[320px]  xs:w-[350px] md:overflow-x-visible md:w-[400px]">
              <div className="flex items-center note-modal-icon  ">
                <button>
                  <CodeIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <BoldIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button onClick={toggleItalic}>
                  <ItalicIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <UnderlineIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <AlignLeftIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <AlignRightIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <AlignJustifyIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <AlignMiddleIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button>
                  <ImageIcon />
                </button>
                <span className=" w-[1px] h-[18px] bg-black opacity-20 block mx-[10px]"></span>
                <button
                  onClick={changeTextColor}
                  className=" flex items-center relative">
                  <ColorLensIcon />
                  <span className="pl-1 note-modal-arrow">
                    <ColorLensArrowIcon />
                  </span>

                  <div className=" absolute top-[30px] right-[30%] z-30">
                    {showColorModal && (
                      <ColorPickerModal
                        changeTextColor={changeTextColor}
                        handleColorChange={handleColorChange}
                        color={color}
                      />
                    )}
                  </div>
                </button>
              </div>
            </div> */}
            {/* <div onClick={() => setShowColorModal(false)} className=" bg-white">
              <textarea
                style={textStyles}
                id="text-to-change"
                className="w-full p-2 outline-none resize-none text-black placeholder:text-black placeholder:opacity-[0.21]  font-normal text-xs"
                cols="10"
                rows="14"
                placeholder="Add notes about their recent chat"></textarea>
            </div> */}
            <RichTextEditor value={value} onChange={onChange} />
          </div>
          <div className="flex justify-end pt-6">
            <button
              onClick={overLayHidden}
              type="submit"
              className="text-[14px] font-semibold text-white rounded-[26px] border border-soild border-transparent  outline-none p-[12px_25px] xl:w-[90px] bg-primary  hover:bg-white hover:text-primary hover:border-primary duration-200"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogChatNotesModal;
